// extracted by mini-css-extract-plugin
export default {"Wrapper":"LegendItem_Wrapper__e2Gij","LegendSquare":"LegendItem_LegendSquare__ZIcz6"};